import { render, staticRenderFns } from "./FeaturedDocuments.vue?vue&type=template&id=9a22db16&"
import script from "./FeaturedDocuments.vue?vue&type=script&lang=js&"
export * from "./FeaturedDocuments.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedDocuments.vue?vue&type=style&index=0&id=9a22db16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports